import { defineVideoTemplate } from "@assets/templates/builders";
import { BASE_ASSETS } from "@assets/templates/constants";

export const soccerVideoExample = defineVideoTemplate({
  slug: "soccer-video-example",
  title: "Soccer",
  description: "Highlight detection",
  subdescription: "Highlight the moments that matter in a match",
  poster: BASE_ASSETS.soccerVideoPoster,
  video: BASE_ASSETS.soccerVideo,
  prompt: "Describe this scene in detail. Summarize the frames into key events.",
  enableThinking: true,
});
